import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { LanguageProvider } from "@/LanguageContext";
import { Toaster } from "@/components/ui/sonner";
import HomePage from "@/components/HomePage";
import ProductDetail from "@/components/ProductDetail";
import { Navbar } from "@/components/Navbar";

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <div className="App">
          <Navbar />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/product/:id" element={<ProductDetail />} />
          </Routes>
          <Toaster position="top-right" richColors />
        </div>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
